
import { Plan } from "@/models/plan";
import { Subscription } from "@/models/subscription";
import Vue from "vue";
export default Vue.extend({
	props: {
		sub: {
			type: Object as ()=>Subscription,
			required: true
		}
	},
	methods: {
		onBackClicked(){
			this.sub.plan = new Plan(JSON.parse(this.sub.rawMetadata));
			this.$emit("back");
		}
	}
});
